import {useContext} from 'react';
import {StoreContext} from 'store/context';

type ActionCreator = (payload?: ActionPayload) => Action;
type ActionPerformer = (payload?: ActionPayload) => void;

export function useDispatch(action: ActionCreator, payload?: ActionPayload): ActionPerformer {
  const {dispatch} = useContext(StoreContext);

  return function callAction(runtimePayload?: ActionPayload): void {
    dispatch(action(payload ?? runtimePayload));
  };
}
